import { Component, Input } from "@angular/core";
import { ITreeViewMetadata } from "@tylertech/tyler-api-types";
import { RepositoryFormData } from "../../../interfaces";

@Component({
    selector: "metadata-tree",
    templateUrl: "./metadata.tree.tmpl.html",
    standalone: false
})
export class MetadataTreeComponent 
{
    @Input() viewMetadata: ITreeViewMetadata;
    @Input() entities: any[];
    @Input() datacontroller: RepositoryFormData;

    constructor() { }
}
